import React, { useEffect, useState } from "react";
import Head from "../layout/head/Head";
import Content from "../layout/content/Content";
import { Badge, Card, CardTitle } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import { Puff } from "react-loader-spinner";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'
import {
  Block,
  BlockHead,
  BlockTitle,
  Row,
  Col,
} from "../components/Component";
import {
  Link,
  json,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  fetchApmPaymentMethods,
  fetchAPMs,
  fetchAPMsToggle,
  fetchBannerData,
  fetchPaymentMethods,
  fetchRandomGateways,
  fetchService,
  fetchSingleAPMs,
  fetchSingleCountries,
  fetchSingleCountry,
  getCountryAPMs,
} from "../utils/api";
import { Button } from "react-bootstrap";
import Usericon from "../assets/images/add_user_icon.png";
import { useTheme } from "styled-components";
import services from "../utils/services";

const SinglePayment = () => {
  const route = useParams();
  const { state } = useLocation();

  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const handleClose = () => setShow(false);

  const [bankingData, setBankingData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [typesData, setTypesData] = useState([]);
  const [apmCountry, setApmCountry] = useState([]);
  const [featureShow, setFeatureShow] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalName, setModalName] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [checkboxStates, setCheckboxStates] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [randomServices, setRandomServices] = useState([]);
  const [cart, setCart] = useState(0);
  const [cartData, setCartData] = useState([]);
  const [select_cart, setSelectCart] = useState({});
  const [checkboxAvailable, setCheckboxAvailable] = useState(
    new Array(typesData.length).fill(false)
  );

  const [selectItem, setSelectItem] = useState([]);
  const [top_apm_providers, setTopApmProviders] = useState([]);
  const [logoData, setLogoData] = useState([]);

  const handleCheckout = () => {
    navigate("/cart");
  };

  const handleAvailable = (index, data) => {
    const updatedavailable = [...checkboxAvailable];
    updatedavailable[index] = !updatedavailable[index]; // Toggle the value
    setCheckboxAvailable(updatedavailable);

    if (updatedavailable[index]) {
      setCart(cart + 1); // Increment the cart count
      const updatedCartData = [...cartData, data]; // Add item ID to cartData
      setCartData(updatedCartData);
      localStorage.setItem("cartValue", cart + 1);
      localStorage.setItem("cartDataStore", JSON.stringify(updatedCartData)); // Store the cart data in localStorage
    } else {
      setCart(cart - 1); // Decrement the cart count
      const updatedCartData = cartData.filter((item) => item.id !== data.id); // Remove item ID from cartData
      setCartData(updatedCartData);
      localStorage.setItem("cartValue", cart - 1);
      localStorage.setItem("cartDataStore", JSON.stringify(updatedCartData)); // Update the cart data in localStorage
    }
  };

  const handleToggle = (data) => {
    const updatedStates = checkboxStates;
    setCheckboxStates(!updatedStates);
    if (!updatedStates) {
      setSelectCart({ ...data, added_apm: [] });
      setCart(cart + 1);
      const updatedCartData = [...cartData, data];
      setCartData(updatedCartData);

      localStorage.setItem("cartValue", cart + 1);
      localStorage.setItem("cartDataStore", JSON.stringify(updatedCartData));
    } else {
      const updatedCartData = cartData.filter((item) => item.id !== data.id); // Remove the item with the matching id
      setCartData(updatedCartData);
      setCart(cart - 1);
      localStorage.setItem("cartValue", cart - 1);
      localStorage.setItem("cartDataStore", JSON.stringify(updatedCartData));
    }
  };

  const getServiceData = () => {

    const serviceFormate = services?.map((type) => ({
      value: type.name, // Use type code as value
      label: type.id, // Use common name as label
    }));

    setServiceData(serviceFormate);
    const filteredData = serviceFormate.filter(
      (item) => item.value !== "APMs" && item.value !== "Payment Gateways"
    );
    const shuffled = filteredData?.sort(() => 0.5 - Math.random()); // Shuffle the array
    setRandomServices(shuffled);

  };

  useEffect(() => {
    if (loader === true) {
      setTimeout(() => {
        setLoader(false)
      }, 5000)
    }
  }, [loader])

  useEffect(() => {
    if (!state?.type) {
      setLoader(true);
      getSingleCountrydata();
      getPaymentMethods()
      getServiceData();
    } else {
      setLoader(true);
      if (state?.type.includes('Payment Gateways')) {
        getRandomGateways();
      } else {
        getApmDesc();
      }
      getSingleApms();
      getApmCountry();
      // getApmPaymentMethods()
    }

    const storedCart = localStorage.getItem("cartValue");
    const storedCartData = localStorage.getItem("cartDataStore");

    if (storedCart) {
      setCart(parseInt(storedCart, 10)); // Initialize cart count
    }
    if (storedCartData) {
      const cartId = JSON.parse(storedCartData);
      const checkID = cartId?.map((item) => {
        if (item?.id == state?.id) {
          setCheckboxStates(true);
          setSelectCart({ ...item, added_apm: item?.added_apm || [] });
        }
      });
      setCartData(cartId);
    }
  }, [state]);


  useEffect(() => {
    fetchBannerData()
      .then((res) => {
        setLogoData(res?.data?.[0]);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  }, [])

  const handleSelectItem = (item) => {
    if (checkboxStates) {
      let data = select_cart;
      if (data?.added_apm?.length > 0) {
        let is_exist;
        for (let i = 0; i < data.added_apm.length; i++) {
          if (data.added_apm[i].label === item.label) {
            is_exist = i;
          }
        }
        if (is_exist) {
          data.added_apm.splice(is_exist, 1);
          document.getElementById(item.label).classList.remove("badge-matched");
        } else {
          data.added_apm.push(item);
          document.getElementById(item.label).classList.add("badge-matched");
          setSelectItem({ ...selectItem, item });
        }
      } else {
        document.getElementById(item.label).classList.add("badge-matched");
        data?.added_apm?.push(item);
      }
      setSelectCart(data);
      const storecart = localStorage.getItem("cartDataStore");
      const newStore = JSON.parse(storecart);
      for (let i = 0; i < newStore.length; i++) {
        if (newStore[i].id === state.id) {
          newStore[i].added_apm = data.added_apm;
        }
      }
      localStorage.setItem("cartDataStore", JSON.stringify(newStore));
    }
  };

  const getSingleCountrydata = () => {
    // setLoader(true);
    const id = state?.id;
    fetchSingleCountries(id)
      .then((res) => {
        setTimeout(() => {
          // setLoader(false);
          if (res?.data) {
            setFeatureShow(true);
          }
        }, 1000);
        setCountryData(res.data);
        let data = res.data?.payment_and_banking_providers;
        data = data
          .replace(/'/g, '"')
          .replace(/(\w)"(\w)/g, "$1'$2")
          .replace(/(\s)"(\w)/g, '$1"$2');
        const parsedData = JSON.parse(data);
        setBankingData(parsedData);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  };

  const getPaymentMethods = () => {
    const id = state?.id;
    fetchPaymentMethods(id).then(res => {
      setTopApmProviders(res.data)
      // setTimeout(() => {
      //   setLoader(false);
      // }, 1000);
    }).catch((error) => {
      console.log(error);
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    });
  }

  const getApmPaymentMethods = () => {
    setLoader(true);
    fetchApmPaymentMethods()
      .then((res) => {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        setTopApmProviders(res.data);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  }


  const getSingleApms = () => {
    const id = state?.id;
    // setLoader(true);
    fetchSingleAPMs(id)
      .then((res) => {
        setCountryData(res.data);
        if (res.data?.apm_togal !== undefined) {
          setIsChecked(res?.data?.apm_togal);
        }
        setTimeout(() => {
          // setLoader(false);
          if (res?.data) {
            setFeatureShow(true);
          }
        }, 1000);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  };

  const getApmDesc = () => {
    // const selectedTypesNames = state?.service__name;
    // const selectedCategoryNames = state?.category;
    fetchApmPaymentMethods()
      .then((res) => {
        setTypesData(res.data);
        // setTimeout(() => {
        //   setLoader(false);
        // }, 1000);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  };

  const getRandomGateways = () => {
    fetchRandomGateways()
      .then((res) => {
        if (res && res?.data && Array.isArray(res?.data))
          setTypesData(res?.data);
        else
          setTypesData([]);
        // setTimeout(() => {
        //   setLoader(false);
        // }, 1000);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  }

  const navigate = useNavigate();

  const handleNavigate = (type_name, category, service, id) => {

    const body = {
      country: state?.country ? state?.country : "",
      type: type_name ? service ? service : state?.type : "",
      category: category ? category : "",
      service: service ? service : "",
      id: id,
    };
    console.log(type_name, category, id, body)

    navigate(`/${type_name}`, { state: body });
  };

  const getApmCountry = () => {
    const id = route?.id;
    setLoader(true);
    getCountryAPMs(id)
      .then((res) => {
        setApmCountry(res?.data);
        // setTimeout(() => {
        //   setLoader(false);
        // }, 1000);
      })
      .catch((error) => {
        console.log(error);
        setApmCountry([]);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      });
  };

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  const handleModal = (name, data, value) => {
    setShow(true);
    setModalName(name);
    if (value) {
      setModalDescription(data);
      setModalData([]);
    } else {
      setModalData(data);
      setModalDescription("");
    }
  };

  useEffect(() => {
    if (randomServices.length > 0 && !loader) {
      const storedCartData = localStorage.getItem("cartDataStore");
      if (storedCartData) {
        const cartId = JSON.parse(storedCartData);
        const checkID = cartId?.map((item) => {
          if (item?.id == state?.id) {
            if (item?.added_apm) {
              let apm = item?.added_apm;
              for (let i = 0; i < apm.length; i++) {
                document
                  .getElementById(apm[i].label)
                  ?.classList.add("badge-matched");
              }
            }
          }
        });
      }
    }
  }, [randomServices, loader]);


  return (
    <div className="">
      <Head title="Profile" />
      {loader ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <Puff color="#1a2853" />
          </div>
        </>
      ) : (
        <Content>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <img
              src={logoData?.logo_image}
              alt="logo"
              width={100}
              height={100}
              style={{ borderRadius: "60px", cursor: "pointer" }}
              onClick={() => navigate("/")}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={Usericon}
                alt="usericon"
                style={{ marginRight: "10px", width: "38px", height: "38px" }}
              />
              {cart > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    cursor: "pointer",
                    marginTop: "18px",
                  }}
                  onClick={() => {
                    handleCheckout();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="currentColor"
                    className="bi bi-cart-check-fill"
                    viewBox="0 0 16 16"
                    style={{ color: "#1a2853" }}
                  >
                    <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708" />
                  </svg>
                  <div className="text-end">
                    <span className="togal_count">{cart}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <BlockHead>
            <button className="back_btn" onClick={() => handleBackClick()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                className="bi bi-chevron-left"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                />
              </svg>
              {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            className="bi bi-arrow-left-circle-fill"
            viewBox="0 0 16 16"
          >
            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
          </svg> */}
            </button>

            <Row>
              <Col lg={12} className="my-3">
                <Row>
                  <Col lg={6}>
                    {(countryData?.image || countryData?.apm_logo) && (
                      <Card className="card-full py-3 mx-5 text-left single_card">
                        <img
                          src={`${countryData?.image
                            ? countryData?.image
                            : countryData.apm_logo
                            }`}
                          style={{
                            width: "300px !important",
                            height: "100% !important",
                          }}
                          width={300}
                          className="my-1 m-auto"
                          alt=""
                        />{" "}
                      </Card>
                    )}
                  </Col>
                  <Col lg={6}>
                    <div className="card-inner">
                      <div className="badges_toggle">
                        <div></div>
                        {countryData && (
                          <div
                            className="preview-block"
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span data-tooltip-id="my-tooltip" data-tooltip-content={`Click on the toogle icon to add product to your cart ${!state?.type ? "and select services of your chioce" : ""}`}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width="20"
                                height="20"
                                viewBox="0 0 50 50"
                              >
                                <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"></path>
                              </svg>
                            </span>
                            <ReactTooltip id="my-tooltip" place="top" type="dark" effect="solid" />
                            <div className="custom-control custom-switch" style={{ marginLeft: "10px" }}>
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`customSwitch123`}
                                checked={checkboxStates} // Bind to state
                                onChange={() => handleToggle(countryData)}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={`customSwitch123`}></label>
                              {/* <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`customSwitch123`}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={`customSwitch123`}
                            ></label> */}
                            </div>
                          </div>
                        )}
                      </div>
                      <CardTitle>
                        <h5 className="title">
                          {countryData?.name} {countryData?.country_name}
                        </h5>
                      </CardTitle>{" "}
                      <p className="fatf_status mt-1">
                        {countryData?.fatf_status}
                      </p>
                      <p className="card-text mt-4">
                        {countryData?.compliance}
                        {countryData?.description?.slice(0, 400)}
                      </p>{" "}
                      {/* {[
                        ...new Set(
                          countryData?.top_apm_providers?.map(
                            (item) => item?.service
                          )
                        ),
                      ].map((serviceName, i) => {
                        return (
                          <Badge
                            key={i}
                            className="btn btn-primary badge_name p-1"
                          >
                            {serviceName}
                          </Badge>
                        );
                      })} */}
                      {countryData && state?.payment == "Payment Gateways" && (
                        <Badge className="btn btn-primary mx-1  badge_name py-1 my-1">
                          Payment Gateways
                        </Badge>
                      )}
                      {countryData?.category?.split(",")?.map((item, i) => {
                        return (
                          <Badge className="btn btn-primary badge_name mx-1 py-1 my-1 pr-0">
                            {item}
                          </Badge>
                        );
                      })}
                      {countryData?.country_name &&
                        randomServices?.map((item, i) => {
                          return (
                            <Badge
                              key={i}
                              id={item.label}
                              className={`btn btn-primary mx-1  ${checkboxStates ? "badge_name" : "disable_badge_name"} py-1 my-1`}
                              onClick={() => handleSelectItem(item)}
                            >
                              {item?.value}
                            </Badge>
                          );
                        })}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </BlockHead>

          {featureShow && (
            <>
              <Block>
                <div className="feature_bg">
                  {!state?.type ? (
                    <Row>
                      <Col lg={4}>
                        <div className="feature_outer">
                          <h5>Payment and Banking Providers</h5>
                          <Row className="mt-3">
                            <Col lg={12}>
                              <div
                                style={{
                                  color: "white",
                                  display: "block !important",
                                }}
                              >
                                <p>
                                  {bankingData
                                    ?.slice(0, 5)
                                    ?.map((bank, index) => {
                                      return (
                                        <span
                                          key={index}
                                          style={{
                                            whiteSpace: "nowrap !important",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {bank}
                                          {index <
                                            bankingData.slice(0, 5).length -
                                            1 && ", "}
                                        </span>
                                      );
                                    })}
                                </p>

                                {bankingData?.length > 5 && (
                                  <button
                                    onClick={() =>
                                      handleModal(
                                        "Payment and Banking Providers",
                                        bankingData
                                      )
                                    }
                                    className="see_more mt-4"
                                  >
                                    SEE MORE
                                  </button>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="feature_outer">
                          <h5>Payment Methods</h5>
                          <div className="mt-3">
                            <div style={{ color: "white" }}>
                              <p>
                                {countryData?.payment_methods
                                  ?.slice(0, 5)
                                  ?.map((item, index) => {
                                    return (
                                      <span
                                        key={index}
                                        style={{
                                          whiteSpace: "nowrap !important",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {item.name}
                                        {index <
                                          countryData?.payment_methods.slice(
                                            0,
                                            5
                                          ).length -
                                          1 && ", "}
                                      </span>
                                    );
                                  })}
                              </p>

                              {countryData?.payment_methods?.length > 5 && (
                                <button
                                  onClick={() =>
                                    handleModal(
                                      "Payment Methods",
                                      countryData?.payment_methods
                                    )
                                  }
                                  className="see_more mt-4"
                                >
                                  SEE MORE
                                </button>
                              )}
                            </div>
                          </div>
                          {/* <Link to="/" className="see_more">
                    SEE MORE
                  </Link> */}
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="feature_outer">
                          <h5>Top APM Providers</h5>
                          <div className="mt-3 " style={{ color: "white" }}>
                            <p>
                              {countryData?.top_apm_providers?.slice(0, 5)?.map((service, index) => {
                                return (
                                  <span
                                    key={index}
                                    style={{
                                      whiteSpace: "nowrap !important",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {" "}
                                    {service.name}
                                    {index <
                                      countryData?.top_apm_providers.slice(
                                        0,
                                        5
                                      ).length -
                                      1 && ", "}
                                  </span>
                                );
                              })}
                            </p>
                            {countryData?.top_apm_providers?.length > 0 && (
                              <button
                                onClick={() =>
                                  handleModal(
                                    "Top APM Providers",
                                    countryData?.top_apm_providers
                                  )
                                }
                                className="see_more mt-4"
                              >
                                SEE MORE
                              </button>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col lg={4}>
                        {state?.service__name?.includes("Payment Gateways") ? (
                          <div className="feature_outer">
                            <h5 style={{ textTransform: "uppercase" }}>
                              Automatic Card Updater :
                            </h5>
                            <p style={{ fontWeight: "600" }}>
                              {countryData?.automatic_card_updater}
                            </p>
                          </div>
                        ) : (
                          <div className="feature_outer">
                            <h5>FEATURES</h5>
                            <Row className="mt-3">
                              {countryData?.features &&
                                countryData?.features
                                  ?.split(",")
                                  ?.slice(0, 4)
                                  ?.map((item, i) => {
                                    return (
                                      <Col lg={6} className="px-5 my-1" key={i}>
                                        <div className="custom-control custom-checkbox">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            checked={true}
                                            id="customCheck22"
                                          />
                                          <label
                                            className="custom-control-label feature_text"
                                            htmlFor="customCheck22"
                                          >
                                            {item}
                                          </label>
                                        </div>
                                      </Col>
                                    );
                                  })}
                              {/* <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    checked={true}
                                    id="customCheck21"
                                  />
                                  <label
                                    className="custom-control-label feature_text"
                                    htmlFor="customCheck21"
                                  >
                                    Refunds
                                  </label> */}
                              {/* <Col lg={6}>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    checked={true}
                                    id="customCheck22"
                                  />
                                  <label
                                    className="custom-control-label feature_text"
                                    htmlFor="customCheck22"
                                  >
                                    Payln
                                  </label>
                                </div>
                              </Col> */}
                            </Row>
                          </div>
                        )}
                      </Col>
                      <Col lg={4}>
                        <div className="feature_outer">
                          <h5>CURRENCIES</h5>
                          <div className="mt-3">
                            <p>
                              <span style={{ fontWeight: "600" }}>
                                {" "}
                                {countryData?.currencies?.slice(0, 39)}
                              </span>
                            </p>
                            {countryData?.currencies && (
                              <button
                                onClick={() =>
                                  handleModal(
                                    "CURRENCIES",
                                    countryData?.currencies,
                                    "true"
                                  )
                                }
                                className="see_more"
                              >
                                SEE MORE
                              </button>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        {state?.service__name?.includes("Payment Gateways") ? (
                          <div className="feature_outer">
                            <h5 style={{ textTransform: "uppercase" }}>
                              Card Types:
                            </h5>
                            <div className="mt-3 ">
                              <p style={{ fontWeight: "600" }}>
                                {countryData?.cards_types}
                              </p>
                            </div>

                            <button
                              onClick={() =>
                                handleModal(
                                  "CARD TYPES",
                                  countryData?.cards_types,
                                  "true"
                                )
                              }
                              className="see_more mt-4"
                            >
                              SEE MORE
                            </button>
                          </div>
                        ) : (
                          <div className="feature_outer">
                            <h5>SUPPORTED COUNTRIES</h5>
                            <div className="mt-3">
                              {/* <p>
                            {typeof state?.country == "string"
                              ? state?.country
                              : state?.country?.join(", ")}
                          </p> */}

                              <p>
                                {" "}
                                {countryData?.supported_countries ? (
                                  <>
                                    <p>
                                      {countryData?.supported_countries?.slice(
                                        0,
                                        140
                                      )}
                                    </p>
                                  </>
                                ) : apmCountry?.length > 0 ? (
                                  apmCountry
                                    ?.slice(0, 5)
                                    ?.map((item, index) => {
                                      return (
                                        <span
                                          key={index}
                                          style={{
                                            color: "rgb(26, 40, 83)",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {item?.country_name}
                                          {index <
                                            apmCountry.slice(0, 5).length - 1 &&
                                            ", "}
                                        </span>
                                      );
                                    })
                                ) : (
                                  ""
                                )}
                              </p>

                              {countryData?.supported_countries ? (
                                <>
                                  <button
                                    onClick={() =>
                                      handleModal(
                                        "SUPPORTED COUNTRIES",
                                        countryData?.supported_countries,
                                        "true"
                                      )
                                    }
                                    className="see_more"
                                  >
                                    SEE MORE
                                  </button>
                                </>
                              ) : (
                                apmCountry?.length > 5 && (
                                  <button
                                    onClick={() =>
                                      handleModal(
                                        "SUPPORTED COUNTRIES",
                                        apmCountry
                                      )
                                    }
                                    className="see_more"
                                  >
                                    SEE MORE
                                  </button>
                                )
                              )}

                              {/* <p>{state?.country.length > 0 ? state?.country?.join(", ") : ""}</p> */}
                              {/* {apmCountry?.length > 0 && (
                         
                        )} */}
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  )}
                </div>
              </Block>
              <Block>
                {/* <BlockTitle page tag="h2">
              {!state?.type
                ? "Available Payment Methods"
                : "Similar Payment Methods"}
            </BlockTitle> */}
                <Row className="g-gs">
                  <Col lg={12} className="mt-5">
                    <BlockTitle page tag="h1">
                      {state?.service__name?.includes("Payment Gateways")
                        ? "Similar Payment Processor"
                        : state?.type
                          ? "Explore Payment Methods"
                          : "Explore APM Methods"}
                    </BlockTitle>

                    <Row>
                      {!typesData?.length > 0 ? (
                        <>
                          {top_apm_providers?.length > 0 ? (
                            top_apm_providers.map((item, i) => {

                              if (route.id != item?.name && i < 3) {
                                return (
                                  <Col lg={4} className="my-3" key={i}>
                                    <Card className="card-bordered card-full px-4 py-3 text-left service_card">
                                      {" "}
                                      <div
                                        onClick={() =>
                                          handleNavigate(
                                            item?.name,
                                            item?.category,
                                            item?.service,
                                            item?.id
                                          )
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div className="image_outer_section">
                                          <img
                                            src={`${item?.apm_logo
                                              ? item?.apm_logo
                                              : `https://backendmarketplace.ahrvoid.com/media/${item?.apm_image?.replace(
                                                "http://backendmarketplace.ahrvoid.com/media",
                                                ""
                                              )}`
                                              }`}
                                            width={100}
                                            className="card-img-top my-1"
                                            alt=""
                                          />{" "}
                                        </div>{" "}
                                        <CardTitle>
                                          <h5 className="title">
                                            {item.name?.replace("_", " ")}
                                          </h5>
                                        </CardTitle>
                                        <p className="card-text">
                                          {item?.description?.slice(0, 120)?.replace("_", " ")}
                                          ...
                                        </p>{" "}
                                      </div>
                                      <div
                                        className="badges_toggles"
                                        style={{
                                          paddingRight: "0px !important",
                                        }}
                                      >
                                        {" "}
                                        {item?.service__name ==
                                          "Payment Gateways" && (
                                            <Badge className="btn btn-primary mx-1  badge_name py-1 my-1">
                                              Payment Gateways
                                            </Badge>
                                          )}
                                        <Badge className="btn btn-primary badge_name">
                                          {item.category}
                                        </Badge>{" "}
                                        <div className="preview-block">
                                          <div className="custom-control custom-switch">
                                            <input
                                              type="checkbox"
                                              className="custom-control-input"
                                              id={`customSwitch${i}7`}
                                              checked={cartData.some(
                                                (cart) => cart.id === item.id
                                              )}
                                              onChange={() =>
                                                handleAvailable(i, item)
                                              }
                                            />
                                            <label
                                              className="custom-control-label"
                                              htmlFor={`customSwitch${i}7`}
                                            ></label>
                                          </div>
                                        </div>
                                      </div>
                                      {/* </Link> */}
                                    </Card>
                                  </Col>
                                );
                              }
                            })
                          ) : (
                            <></>
                            // <Col lg={12}>
                            //   <Card>
                            //     <div className="not_found">
                            //       <h4>
                            //         There are no payment methods that fit that
                            //         criteria.
                            //         <br />
                            //         Would you like to change that?
                            //       </h4>
                            //     </div>
                            //   </Card>
                            // </Col>
                          )}
                        </>
                      ) : (
                        <>
                          {typesData?.length > 0 && (
                            typesData?.map((service, index) => {
                              return (
                                <Col lg={4} className="my-3" key={index}>
                                  <Card className="card-bordered card-full px-4 py-3 text-left service_card">
                                    {" "}
                                    <div
                                      onClick={() =>
                                        handleNavigate(
                                          service?.name,
                                          service?.category,
                                          null,
                                          service?.id
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div className="image_outer_section">
                                        <img
                                          src={`${service?.image
                                            ? service?.image
                                            : service?.apm_logo
                                            }`}
                                          width={100}
                                          className="card-img-top my-1"
                                          alt=""
                                        />{" "}
                                      </div>{" "}
                                      <CardTitle>
                                        <h5 className="title">
                                          {service.name?.replace("_", " ")}
                                        </h5>
                                      </CardTitle>
                                      <p className="card-text">
                                        {service?.description?.slice(0, 120)?.replace("_", " ")}
                                        ...
                                      </p>{" "}
                                    </div>
                                    <div
                                      className="badges_toggles"
                                      style={{
                                        paddingRight: "0px !important",
                                      }}
                                    >
                                      {service?.service__name ==
                                        "Payment Gateways" && (
                                          <Badge className="btn btn-primary mx-1  badge_name py-1 my-1">
                                            Payment Gateways
                                          </Badge>
                                        )}
                                      <Badge className="btn btn-primary badge_name">
                                        {service.category}
                                      </Badge>{" "}
                                      <div className="preview-block">
                                        <div className="custom-control custom-switch">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id={`customSwitch${index - 1}3`}
                                            checked={cartData.some(
                                              (item) => item.id === service.id
                                            )}
                                            onChange={() =>
                                              handleAvailable(index, service)
                                            }
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor={`customSwitch${index - 1
                                              }3`}
                                          ></label>
                                        </div>
                                      </div>
                                    </div>
                                    {/* </Link> */}
                                  </Card>
                                </Col>
                              );
                            }))
                          }
                        </>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Block>
            </>
          )}
        </Content>
      )}

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="modal_title">{modalName}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span className="modal_list">{modalDescription}</span>
          <p>
            {modalData?.map((item, index) => {
              return (
                <>
                  <span className="modal_list" key={index}>
                    {item?.country_name
                      ? item?.country_name
                      : `${item?.name ? item?.name : item}`}
                    {index !== modalData.length - 1 && ", "}
                  </span>
                  {/* <li>{item?.country_name}</li> */}
                </>
              );
            })}
          </p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SinglePayment;
